import React, { lazy } from 'react'
import { FrontUrls } from 'Constants/FrontUrls'
import { Switch } from 'react-router-dom'
import { LazyRoute, filtersSlice, PAGE_SLUG } from 'Modules'
import { useUnmount } from 'Src/hooks/useUnmount'
import { useAppDispatch } from 'Src/hooks'

const ParentListContainerLazy = lazy(
	() => import('Pages/registry_business_access_neo/common/components/ParentList')
)
const RbidosAccessCreateContainerLazy = lazy(
	() => import('Pages/registry_business_access_neo/rbidosAccess/components/AccessForm')
)
const RbidosLogsContainer = lazy(
	() => import('Pages/registry_business_access_neo/rbidosLogs/components/Logs')
)
const RbidosAgentsLazy = lazy(
	() => import('Pages/registry_business_access_neo/rbidosAgent/components/Agents')
)
const RbidosAgentCreateContainerLazy = lazy(
	() => import('Pages/registry_business_access_neo/rbidosAgent/components/Employee')
)
const RbidosAccessEditContainerLazy = lazy(
	() => import('Pages/registry_business_access_neo/rbidosAgent/components/Employee')
)
const RbidosAgentCreateModalLazy = lazy(
	() => import('Pages/registry_business_access_neo/rbidosAgent/components/CreateEmployee')
)

const actions = {
	clearFilters: filtersSlice.actions.clearFilters,
}

export const RegistryBusinessAccessRoutesNeo = (): JSX.Element => {
	const { clearFilters } = useAppDispatch(actions)
	useUnmount(() => {
		clearFilters(PAGE_SLUG.REGISTRY_BUSINESS_ACCESS_NEO)
	})
	return (
		<Switch>
			<LazyRoute
				path={FrontUrls.cabinet_redesign.registry_business_access_neo_edit}
				lazyComponent={RbidosAccessEditContainerLazy}
				key={FrontUrls.cabinet_redesign.registry_business_access_neo_edit}
			/>
			<LazyRoute
				path={FrontUrls.cabinet_redesign.registry_business_access_neo_logs}
				lazyComponent={RbidosLogsContainer}
				key={FrontUrls.cabinet_redesign.registry_business_access_neo_logs}
			/>
			<LazyRoute
				path={FrontUrls.cabinet_redesign.registry_business_access_neo_order_agents}
				lazyComponent={RbidosAgentsLazy}
				key={FrontUrls.cabinet_redesign.registry_business_access_neo_order_agents}
			/>
			<LazyRoute
				path={FrontUrls.cabinet_redesign.registry_business_access_neo_modal}
				lazyComponent={RbidosAgentCreateModalLazy}
				key={FrontUrls.cabinet_redesign.registry_business_access_neo_modal}
			/>
			<LazyRoute
				path={FrontUrls.cabinet_redesign.registry_business_access_neo_create_agent}
				lazyComponent={RbidosAgentCreateContainerLazy}
				key={FrontUrls.cabinet_redesign.registry_business_access_neo_create_agent}
			/>
			<LazyRoute
				path={FrontUrls.cabinet_redesign.registry_business_access_neo_create}
				lazyComponent={RbidosAccessCreateContainerLazy}
				key={FrontUrls.cabinet_redesign.registry_business_access_neo_create}
			/>
			<LazyRoute
				path={FrontUrls.cabinet_redesign.registry_business_access_neo_index}
				lazyComponent={ParentListContainerLazy}
				key={FrontUrls.cabinet_redesign.registry_business_access_neo_index}
			/>
		</Switch>
	)
}
